import { useState } from "react";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";

export default function Register() {
    const [step, setStep] = useState(1); // Tracks current step
    const [restaurantId, setRestaurantId] = useState<number | null>(null); // Stores restaurant ID after step 1

    const handleNextStep = (id: number) => {
        setRestaurantId(id);
        setStep(2);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            {step === 1 ? (
                <RegisterStep1 onNext={handleNextStep} />
            ) : (
                restaurantId && <RegisterStep2 restaurantId={restaurantId} />
            )}
        </div>
    );
}
